import { isFcmUnsupportedError } from "./utils/fcm-error";

/**
 * Benign third-party unhandled rejections kept out of the browser console.
 * Console only — Sentry captures these through its own instrumentation, so an
 * entry here usually needs a matching `ignoreErrors`/`beforeSend` rule in the
 * `Sentry.init` call in index.tsx.
 */
const SUPPRESSED_REJECTIONS: ReadonlyArray<{
  name: string;
  matches: (reason: unknown) => boolean;
}> = [
  // @ethora/chat-component eagerly initializes Firebase Cloud Messaging at
  // import time; its isSupported() rejection escapes the library's try/catch
  // (see ./utils/fcm-error for the full explanation). This dashboard does not
  // use FCM.
  { name: "fcm-unsupported-browser", matches: isFcmUnsupportedError },
];

window.addEventListener("unhandledrejection", event => {
  if (SUPPRESSED_REJECTIONS.some(({ matches }) => matches(event.reason))) {
    event.preventDefault();
  }
});
